'use strict';

angular.module('paizacloudApp')
  .config(function($translateProvider){
    /* $translateProvider.useStaticFilesLoader({
      prefix: '/assets/i18/locale-',
      suffix: '.json',
    });*/
    $translateProvider.translations('en', require('../assets/i18n/locale-en.json'));
    $translateProvider.translations('ja', require('../assets/i18n/locale-ja.json'));

    let lang = $translateProvider.resolveClientLocale();
    if(lang && lang.substr(0, 2) === "ja"){
      lang = 'ja';
    }else{
      lang = 'en';
    }
    // $translateProvider.preferredLanguage(lang);
    $translateProvider.preferredLanguage(lang);
    $translateProvider.useCookieStorage();

  })
  .run(($rootScope, $translate) => {
    window.locale = $rootScope.locale = $translate.use();
    $("html").attr("lang", window.locale);
  });


